import { makeActionCreator } from '../../modules/utilities/store'
import AC_TYPES from '../types/AC'

const ACActions = {
  setPermissions: makeActionCreator(AC_TYPES.SET_PERMISSIONS, 'roleId', 'permissionKeys'),
  clearPermissions: makeActionCreator(AC_TYPES.CLEAR_PERMISSIONS),
  setRoles: makeActionCreator(AC_TYPES.SET_ROLES, 'roles')
}

export default ACActions
